import { faGear, faHome, faStore, faUser, faPuzzlePiece, faFileCheck } from "@fortawesome/pro-light-svg-icons"
import {
    SUPPLIER_ADMIN_ACCOUNT_COMPANY_ROUTE,
    SUPPLIER_ADMIN_ACCOUNT_GDPR_ROUTE,
    SUPPLIER_ADMIN_ACCOUNT_ROUTE,
    SUPPLIER_ADMIN_ACQUIRING_REPORTS_BALANCE_ROUTE,
    SUPPLIER_ADMIN_ACQUIRING_REPORTS_ACQUIRING_FEES_ROUTE,
    SUPPLIER_ADMIN_ACQUIRING_REPORTS_BANK_TRANSFERS_ROUTE,
    SUPPLIER_ADMIN_ACQUIRING_REPORTS_ROUTE,
    SUPPLIER_ADMIN_ACQUIRING_ROUTE,
    SUPPLIER_ADMIN_ADMINISTRATORS_ROUTE,
    SUPPLIER_ADMIN_DEVICES_ROUTE,
    SUPPLIER_ADMIN_ERP_ROUTE,
    SUPPLIER_ADMIN_MERCHANT_ADMINISTRATORS_ROUTE,
    SUPPLIER_ADMIN_MERCHANTS_LIST_ROUTE,
    SUPPLIER_ADMIN_MERCHANTS_ROUTE,
    SUPPLIER_ADMIN_POS_SETTINGS_ROUTE,
    SUPPLIER_ADMIN_PRODUCT_NUMBERS_ROUTE,
    SUPPLIER_ADMIN_ROUTE,
    SUPPLIER_ADMIN_SETTINGS_ROUTE,
    SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_ROUTE,
} from "../../../../constants/routes"
import { NavMenuItem } from "../../../../shared/layouts/components/NavMenuItem"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { NavMenuItemGroupWrapper, NavMenuSubItem } from "../../../../shared/layouts/components/NavMenuItemGroup"
import { MatchEnvironment } from "../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../environment/envTypes"

export function SupplierAdminNavItems() {
    return (
        <>
            <LocalizedStrict id="supplier-nav-item-home">
                <NavMenuItem icon={faHome} dest={SUPPLIER_ADMIN_ROUTE}>
                    Home
                </NavMenuItem>
            </LocalizedStrict>
            <LocalizedStrict id="supplier-nav-item-merchants-page-header" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faStore} dest={SUPPLIER_ADMIN_MERCHANTS_ROUTE} title="Merchants">
                    <LocalizedStrict id="supplier-admin-nav-item-merchants">
                        <NavMenuSubItem route={SUPPLIER_ADMIN_MERCHANTS_LIST_ROUTE}>Merchants</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="supplier-admin-nav-item-devices">
                        <NavMenuSubItem route={SUPPLIER_ADMIN_DEVICES_ROUTE}>Devices</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="supplier-admin-nav-item-admins">
                        <NavMenuSubItem route={SUPPLIER_ADMIN_MERCHANT_ADMINISTRATORS_ROUTE}>
                            Administrators
                        </NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
            <MatchEnvironment environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}>
                <LocalizedStrict id="supplier-nav-item-erp-page-header" attrs={{ title: true }}>
                    <NavMenuItemGroupWrapper icon={faPuzzlePiece} dest={SUPPLIER_ADMIN_ERP_ROUTE} title="ERP">
                        <LocalizedStrict id="supplier-admin-nav-item-product-numbers">
                            <NavMenuSubItem route={SUPPLIER_ADMIN_PRODUCT_NUMBERS_ROUTE}>
                                Product numbers
                            </NavMenuSubItem>
                        </LocalizedStrict>
                    </NavMenuItemGroupWrapper>
                </LocalizedStrict>
            </MatchEnvironment>
            <LocalizedStrict id="supplier-nav-item-acquiring-reports-page-header" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper
                    icon={faFileCheck}
                    dest={SUPPLIER_ADMIN_ACQUIRING_REPORTS_ROUTE}
                    title="Reconciliation"
                >
                    <LocalizedStrict id="supplier-nav-item-balance">
                        <NavMenuSubItem route={SUPPLIER_ADMIN_ACQUIRING_REPORTS_BALANCE_ROUTE}>Balance</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="supplier-admin-nav-item-acquiring-fees">
                        <NavMenuSubItem route={SUPPLIER_ADMIN_ACQUIRING_REPORTS_ACQUIRING_FEES_ROUTE}>
                            Acquiring fees
                        </NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="supplier-admin-nav-item-bank-transfers">
                        <NavMenuSubItem route={SUPPLIER_ADMIN_ACQUIRING_REPORTS_BANK_TRANSFERS_ROUTE}>
                            Bank transfers
                        </NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
            <LocalizedStrict id="supplier-nav-item-settings-page-header" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faGear} dest={SUPPLIER_ADMIN_SETTINGS_ROUTE} title="Settings">
                    <LocalizedStrict id="supplier-admin-nav-item-acquiring">
                        <NavMenuSubItem route={SUPPLIER_ADMIN_ACQUIRING_ROUTE}>Payment Acquiring</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="supplier-admin-nav-item-terms-and-conditions">
                        <NavMenuSubItem route={SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_ROUTE}>
                            Terms and Conditions
                        </NavMenuSubItem>
                    </LocalizedStrict>
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}
                    >
                        <LocalizedStrict id="supplier-admin-nav-item-pos-settings">
                            <NavMenuSubItem route={SUPPLIER_ADMIN_POS_SETTINGS_ROUTE}>POS settings</NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
            <LocalizedStrict id="supplier-nav-item-account-page-header" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faUser} dest={SUPPLIER_ADMIN_ACCOUNT_ROUTE} title="Account">
                    <LocalizedStrict id="supplier-admin-nav-item-admins">
                        <NavMenuSubItem route={SUPPLIER_ADMIN_ADMINISTRATORS_ROUTE}>Administrators</NavMenuSubItem>
                    </LocalizedStrict>
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}
                    >
                        <LocalizedStrict id="supplier-admin-nav-item-company-account">
                            <NavMenuSubItem route={SUPPLIER_ADMIN_ACCOUNT_COMPANY_ROUTE}>
                                Company account
                            </NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                    <LocalizedStrict id="supplier-admin-nav-item-account-gdpr">
                        <NavMenuSubItem route={SUPPLIER_ADMIN_ACCOUNT_GDPR_ROUTE}>GDPR</NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
        </>
    )
}
